@if (!isCustomerModule && !isFromQuickstartRentUnit) {
  <div class="prospect_top_sec">
    <h5 class="prospectsHeader">Invoice Setting</h5>
    <div>
      <app-call-script [section]="section"></app-call-script>
    </div>
  </div>
}
<form [formGroup]="invoiceSettingsForm" novalidate>
  <div class="row mt-3 align-items-center" style="grid-gap:0px;">
    <div class="col-md-4 col-sm-6">
      <div class="d-flex align-items-center">
        <label class="pure-material-checkbox mb-0 me-3">
          <input type="checkbox" formControlName="SendInvoice" (click)="enableOtherFields($event.target.checked)"
            appHighlightCallScriptFields [fieldName]="'SendInvoice'"
            [linkedFieldsList]="invoiceSettingCallScriptFields">
            <span>Send Invoice</span>
          </label>
        </div>
      </div>
      <div class="col-md-4 col-sm-6">
        <div class="d-flex align-items-center">
          <span style="margin-right:10px">Number of Periods</span>
          <input type="number" class="form-control inputresp" style="width: 70px" formControlName="InvoicePeriods" min="1"
            max="99" (keypress)="numberOnly($event)" (keyup)="validateInvoicePeriods($event.target.value)"
            (paste)="onPaste($event)" appHighlightCallScriptFields [fieldName]="'InvoicePeriods'"
            [linkedFieldsList]="invoiceSettingCallScriptFields" />

            @if (invoiceSettingsForm.get('InvoicePeriods').errors  && (invoiceSettingsForm.get('InvoicePeriods').dirty || invoiceSettingsForm.get('InvoicePeriods').touched)) {
              <div class="alert alert-danger"
                >
                @if (invoiceSettingsForm.get('InvoicePeriods').errors.required) {
                  <span>Invoice
                  Periods is required</span>
                }
                @if (invoiceSettingsForm.get('InvoicePeriods').errors.pattern) {
                  <span> Invalid input </span>
                }
              </div>
            }
          </div>
        </div>
        <div class="col-md-2 col-sm-6">
          <label class="pure-material-checkbox mb-0">
            <input type="checkbox" formControlName="EmailInvoice" (click)="onEmailValidate(template2, $event)"
              appHighlightCallScriptFields [fieldName]="'EmailInvoice'" [linkedFieldsList]="invoiceSettingCallScriptFields">
              <span>Email Invoice</span>
            </label>
          </div>
          <div class="col-md-2 col-sm-6">
            @if (invoiceSettingsForm.get('TaxExempt').value) {
              <label class="pure-material-checkbox mb-0">
                <input type="checkbox" formControlName="TaxExempt" (click)="onTaxExepmtUnChecked()" appHighlightCallScriptFields
                  [fieldName]="'TaxExempt'" [linkedFieldsList]="invoiceSettingCallScriptFields">
                  <span>Tax Exempt</span>
                </label>
              }
              @if (!invoiceSettingsForm.get('TaxExempt').value) {
                <label class="pure-material-checkbox mb-0" data-bs-toggle="modal"
                  data-bs-target="#TaxExemptForm" data-bs-backdrop="static" data-bs-keyboard="false">
                  <input type="checkbox" formControlName="TaxExempt" (click)="onTaxExepmtChecked()" appHighlightCallScriptFields
                    [fieldName]="'TaxExempt'" [linkedFieldsList]="invoiceSettingCallScriptFields">
                    <span>Tax Exempt</span>
                  </label>
                }
              </div>
            </div>
            <div class="row mt-3 align-items-center" style="grid-gap: 0px;">
              <div class="col-md-4 col-sm-6">
                <div class="d-flex align-items-center">
                  <label>Raise Invoice Before</label>
                  <input type="number" class="form-control mx-3 inputresp" style="width: 70px"
                    formControlName="RaiseInvoiceBeforeDays" maxlength="2" min="1" max="60" (keypress)="numberOnly($event)"
                    (keyup)="validateRaiseInvoiceBeforeDays($event.target.value)" appHighlightCallScriptFields
                    [fieldName]="'RaiseInvoiceBeforeDays'" [linkedFieldsList]="invoiceSettingCallScriptFields" />Days
                    @if (invoiceSettingsForm.get('RaiseInvoiceBeforeDays').errors  && (invoiceSettingsForm.get('RaiseInvoiceBeforeDays').dirty || invoiceSettingsForm.get('RaiseInvoiceBeforeDays').touched)) {
                      <div class="alert alert-danger"
                        >
                        @if (invoiceSettingsForm.get('RaiseInvoiceBeforeDays').errors.required) {
                          <span>Raise
                          Invoice Before Days is required</span>
                        }
                        @if (invoiceSettingsForm.get('RaiseInvoiceBeforeDays').errors.pattern) {
                          <span> Invalid input </span>
                        }
                      </div>
                    }
                  </div>
                </div>
                <div class="col-md-4 col-sm-6">
                  <label class="pure-material-checkbox mb-0">
                    <input type="checkbox" formControlName="PostalInvoice" appHighlightCallScriptFields
                      [fieldName]="'PostalInvoice'" [linkedFieldsList]="invoiceSettingCallScriptFields">
                      <span>Postal Invoice</span>
                    </label>
                  </div>
                  <div class="col-md-2 col-sm-6">
                    <label class="pure-material-checkbox mb-0">
                      <input type="checkbox" formControlName="ExemptInvoiceFee" appHighlightCallScriptFields
                        [fieldName]="'ExemptInvoiceFee'" [linkedFieldsList]="invoiceSettingCallScriptFields">
                        <span>Exempt from Invoice Fee</span>
                      </label>
                    </div>
                  </div>

                  <!-- Tax exemption popup -->
                  <div class="modal fade" id="TaxExemptForm" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title">Tax Exemption Form</h5>
                          <button type="button" class="close" aria-label="Close" data-bs-dismiss="modal"
                            (click)="canceltaxExemptForm(template3)">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <div formGroupName="taxExemptForm">
                            <div class="row">
                              <div class="col-md-4">
                                <label>Tax Identification #<span class="required">*</span></label>
                                <input type="text" class="form-control" formControlName="TaxID" maxlength="20"
                                  (keypress)="alphaNumerics($event)" />

                                  @if (invoiceSettingsForm.get('taxExemptForm.TaxID').errors  && (invoiceSettingsForm.get('taxExemptForm.TaxID').dirty || invoiceSettingsForm.get('taxExemptForm.TaxID').touched)) {
                                    <div class="alert alert-danger"
                                      >
                                      @if (invoiceSettingsForm.get('taxExemptForm.TaxID').errors.required) {
                                        <span>Tax
                                        Identification # is required</span>
                                      }
                                      @if (invoiceSettingsForm.get('taxExemptForm.TaxID').errors.whitespace) {
                                        <span i18n="@@Invalid_input">
                    Invalid input</span>
                                      }
                                    </div>
                                  }
                                </div>
                                <div class="col-md-4 pt-3 pt-md-0">
                                  <label>Company</label>
                                  <input type="text" class="form-control" formControlName="CompanyName" maxlength="50" />
                                </div>
                              </div>

                              <div class="row mt-3">
                                <div class="col-md-4">
                                  <label>First Name<span class="required">*</span></label>
                                  <input type="text" class="form-control" maxlength="50" formControlName="FirstName" />
                                  @if (invoiceSettingsForm.get('taxExemptForm.FirstName').errors  && (invoiceSettingsForm.get('taxExemptForm.FirstName').dirty || invoiceSettingsForm.get('taxExemptForm.FirstName').touched)) {
                                    <div class="alert alert-danger"
                                      >
                                      @if (invoiceSettingsForm.get('taxExemptForm.FirstName').errors.required) {
                                        <span>First
                                        Name is required</span>
                                      }
                                      @if (invoiceSettingsForm.get('taxExemptForm.FirstName').errors.whitespace) {
                                        <span>
                                          Invalid
                                        input </span>
                                      }
                                    </div>
                                  }
                                </div>
                                <div class="col-md-4 pt-3 pt-md-0">
                                  <label>Middle Name</label>
                                  <input type="text" class="form-control" maxlength="50" formControlName="MiddleName" />
                                  @if (invoiceSettingsForm.get('taxExemptForm.MiddleName').errors  && (invoiceSettingsForm.get('taxExemptForm.MiddleName').dirty || invoiceSettingsForm.get('taxExemptForm.MiddleName').touched)) {
                                    <div class="alert alert-danger"
                                      >
                                    </div>
                                  }
                                </div>
                                <div class="col-md-4 pt-3 pt-md-0">
                                  <label>Last Name<span class="required">*</span></label>
                                  <input type="text" class="form-control" maxlength="50" formControlName="LastName" />
                                  @if (invoiceSettingsForm.get('taxExemptForm.LastName').errors  && (invoiceSettingsForm.get('taxExemptForm.LastName').dirty || invoiceSettingsForm.get('taxExemptForm.LastName').touched)) {
                                    <div class="alert alert-danger"
                                      >
                                      @if (invoiceSettingsForm.get('taxExemptForm.LastName').errors.required) {
                                        <span>Last
                                        Name is required</span>
                                      }
                                      @if (invoiceSettingsForm.get('taxExemptForm.LastName').errors.whitespace) {
                                        <span>
                                          Invalid
                                        input </span>
                                      }
                                    </div>
                                  }
                                </div>
                              </div>

                              <div class="row mt-3">
                                <div class="col-md-8">
                                  <label>Address</label>
                                  <textarea class="form-control" maxlength="150" formControlName="Address"></textarea>
                                </div>
                                <div class="col-md-4 pt-3 pt-md-0">
                                  <label>Country</label>
                                  <select class="form-select" formControlName="Country" (change)="onCountryChange($event.target.value)">
                                    <option value="" selected>Select</option>
                                    @for (cc of countryList; track cc) {
                                      <option [value]="cc.Id">
                                      {{cc.Name}}</option>
                                    }
                                  </select>
                                </div>
                              </div>

                              <div class="row mt-3">
                                <div class="col-md-4">
                                  <label>State</label>
                                  <select class="form-select" formControlName="State">
                                    @if (!emptyStateList) {
                                      <option value="" selected>Select</option>
                                    }
                                    @if (emptyStateList) {
                                      <option value="0">--</option>
                                    }
                                    @for (st of stateList; track st) {
                                      <option [value]="st.Id">{{st.Name}}
                                      </option>
                                    }
                                  </select>
                                </div>
                                <div class="col-md-4 pt-3 pt-md-0">
                                  <label>City</label>
                                  <input type="text" class="form-control" maxlength="30" formControlName="City" />
                                  @if (invoiceSettingsForm.get('taxExemptForm.City').errors  && (invoiceSettingsForm.get('taxExemptForm.City').dirty || invoiceSettingsForm.get('taxExemptForm.City').touched)) {
                                    <div class="alert alert-danger"
                                      >
                                    </div>
                                  }
                                </div>
                                <div class="col-md-4 pt-3 pt-md-0">
                                  <label>Zip Code</label>
                                  <input type="text" class="form-control" maxlength="15" formControlName="ZipCode"
                                    (keypress)="alphaNumerics($event)" />
                                    @if (invoiceSettingsForm.get('taxExemptForm.ZipCode').errors  && (invoiceSettingsForm.get('taxExemptForm.ZipCode').dirty || invoiceSettingsForm.get('taxExemptForm.ZipCode').touched)) {
                                      <div class="alert alert-danger"
                                        >
                                      </div>
                                    }
                                  </div>
                                </div>

                                <div class="row mt-3">
                                  <div class="col-md-4">
                                    <label>Cell Phone<span class="required">*</span></label>
                                    <div class="form-group mb-0">
                                      <div class="phone_code">
                                        <select class="form-select" formControlName="CellPhoneDialInCode">
                                          <option value="" selected hidden>Select</option>
                                          @for (ct of countryList; track ct) {
                                            <option [value]="ct.Id">
                                            {{ct.DialInCode}}</option>
                                          }
                                        </select>
                                      </div>
                                      <div class="homephone_numb_field">
                                        <ejs-maskedtextbox [mask]="PhoneNumberMask" name="phone" id="inputCellPhone"
                                          formControlName="CellPhone" cssClass="form-control p-0" (focus)="onStartfocus($event)"
                                          (blur)="makeAsDirty()">
                                        </ejs-maskedtextbox>
                                        @if (invoiceSettingsForm.get('taxExemptForm.CellPhone').errors  && (invoiceSettingsForm.get('taxExemptForm.CellPhone').dirty || invoiceSettingsForm.get('taxExemptForm.CellPhone').touched)) {
                                          <div class="alert alert-danger"
                                            >
                                            @if (invoiceSettingsForm.get('taxExemptForm.CellPhone').errors.required) {
                                              <span>Cell
                                              Phone is required</span>
                                            }
                                            @if (invoiceSettingsForm.get('taxExemptForm.CellPhone').errors.lessThanTen) {
                                              <span>Enter 10 digit
                                              Cell Phone Number</span>
                                            }
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4 pt-3 pt-md-0">
                                    <label>Home Phone</label>
                                    <div class="form-group mb-0">
                                      <div class="phone_code">
                                        <select class="form-select" formControlName="HomePhoneDialinCode">
                                          <option value="" selected hidden>Select</option>
                                          @for (ct of countryList; track ct) {
                                            <option [value]="ct.Id">
                                            {{ct.DialInCode}}</option>
                                          }
                                        </select>
                                      </div>
                                      <div class="homephone_numb_field">
                                        <ejs-maskedtextbox [mask]="PhoneNumberMask" name="phone" id="inputhomePhone"
                                          formControlName="HomePhone" cssClass="form-control p-0" (focus)="onStartfocus($event)">
                                        </ejs-maskedtextbox>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-4 pt-3 pt-md-0">

                                    <div class="form-group mb-0">
                                      <div class="phone_code">
                                        <label>Work Phone</label>
                                        <select class="form-select" formControlName="WorkPhoneDialinCode">
                                          <option value="" selected hidden>Select</option>
                                          @for (ct of countryList; track ct) {
                                            <option [value]="ct.Id">
                                            {{ct.DialInCode}}</option>
                                          }
                                        </select>
                                      </div>
                                      <div class="workphone_field">
                                        <label>&nbsp;</label>
                                        <ejs-maskedtextbox [mask]="PhoneNumberMask" name="phone" id="inputworkPhone"
                                          formControlName="WorkPhone" cssClass="form-control p-0" (focus)="onStartfocus($event)">
                                        </ejs-maskedtextbox>
                                      </div>
                                      <div class="ext_no">
                                        <label for="inputworkPhoneExtn">EXT</label>
                                        <input type="text" class="form-control" id="inputworkPhoneExtn" maxlength="10"
                                          formControlName="WorkPhoneExt">
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="row mt-3">
                                    <div class="col-md-4">
                                      <label>Email</label>
                                      <input type="text" class="form-control" formControlName="Email" />
                                      @if (invoiceSettingsForm.get('taxExemptForm.Email').errors  && (invoiceSettingsForm.get('taxExemptForm.Email').dirty || invoiceSettingsForm.get('taxExemptForm.Email').touched)) {
                                        <div class="alert alert-danger"
                                          >
                                          @if (invoiceSettingsForm.get('taxExemptForm.Email').errors.pattern) {
                                            <span i18n="@@Valid_E-mail">
                    Enter Valid E-mail Ids separated by comma or semi colon</span>
                                          }
                                        </div>
                                      }
                                    </div>
                                    <div class="col-md-4 pt-3 pt-md-0">
                                      <label>Fax</label>
                                      <div class="form-group mb-0">
                                        <div class="phone_code">
                                          <select class="form-select" formControlName="FaxDialinCode">
                                            <option value="" selected hidden>Select</option>
                                            @for (ct of countryList; track ct) {
                                              <option [value]="ct.Id">
                                              {{ct.DialInCode}}</option>
                                            }
                                          </select>
                                        </div>
                                        <div class="homephone_numb_field">
                                          <ejs-maskedtextbox [mask]="PhoneNumberMask" name="phone" id="inputFax" formControlName="Fax"
                                          cssClass="form-control p-0" (focus)="onStartfocus($event)"></ejs-maskedtextbox>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button type="button" data-bs-dismiss="modal" class="btn btn-outline-primary me-3"
                                (click)="canceltaxExemptForm(template3)">Cancel</button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" [disabled]="!invoiceSettingsForm.get('taxExemptForm').valid || 
            invoiceSettingsForm.get('taxExemptForm.CellPhone').value == null || 
            invoiceSettingsForm.get('taxExemptForm.CellPhone').value == ''"
                                (click)="taxExemptFormSubmit()">Save</button>
                              </div>

                            </div>
                          </div>
                        </div>
                        <!-- Tax exempt form end-->
                      </form>
                      @if (!isCustomerModule) {
                        <div class="bottom_button_section_pros">
                          <button type="button" class="btn btn-outline-primary me-3" i18n="@@Cancel"
                          (click)="cancelInvoiceModal(template1)">Cancel</button>
                          <button type="button" class="btn btn-primary" [disabled]="isDisabled()" (click)="onSaveInvoice()">Save</button>
                        </div>
                      }

                      <ng-template #template1>
                        <div class="modal-header">
                          <h5 class="modal-title" i18n="@@Confirm">Confirm</h5>
                          <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body ptb24">
                          <p class="m-0" i18n="@@sureCancel">Are you sure you want to cancel? Any data modifications will not be saved.</p>
                        </div>
                        <div class="modal-footer">
                          <button class="btn btn-outline-primary me-3" type="button" (click)="modalRef.hide()" i18n="@@No">No</button>
                          <button class="btn btn-primary" type="button" (click)="onCancelInvoice()" i18n="@@Yes">Yes</button>
                        </div>
                      </ng-template>

                      <ng-template #template2>
                        <div class="modal-body ptb24">
                          <p class="m-0">
                            There is no Email Address Saved for this Tenant!
                            <br>Please Enter a valid Email Address before Selecting this Option to Email Payment Receipt or Invoice
                            </p>
                          </div>
                          <div class="modal-footer">
                            <button class="btn btn-primary" type="button" (click)="modalRef.hide()">OK</button>
                          </div>
                        </ng-template>

                        <ng-template #template3>
                          <div class="modal-header">
                            <h5 class="modal-title" i18n="@@Confirm">Confirm</h5>
                            <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body ptb24">
                            <p class="m-0" i18n="@@sureCancel">Are you sure you want to cancel? Any data modifications will not be saved.</p>
                          </div>
                          <div class="modal-footer">
                            <button class="btn btn-outline-primary me-3" type="button" data-bs-toggle="modal" data-bs-target="#TaxExemptForm"
                            (click)="modalRef.hide()" i18n="@@No">No</button>
                            <button class="btn btn-primary" type="button" (click)="onCancelTaxForm()" i18n="@@Yes">Yes</button>
                          </div>
                        </ng-template>